<script setup lang="ts">
import { MediaToccoDocument, MediaDocument, ToccoSeminarFieldsFragment } from '~/api/graphql/generated'

const props = defineProps<{
  entity: ToccoSeminarFieldsFragment
}>()

const { t } = useI18n()

const downloads = [
  props.entity.fieldPdf && {
    title: t('tocco.registration.seminar.seminarDownloads.pdfBrochureTitle'),
    type: (props.entity.fieldPdf?.entity as MediaDocument)?.fieldMediaDocument?.entity?.filemime || '',
    size: (props.entity.fieldPdf?.entity as MediaDocument)?.fieldMediaDocument?.entity?.filesize || '',
    url: (props.entity.fieldPdf?.entity as MediaDocument)?.fieldMediaDocument?.entity?.url || '',
  },
  props.entity.fieldRegistrationForm && {
    title: t('tocco.registration.seminar.seminarDownloads.registrationDownloadTitle'),
    type: (props.entity.fieldRegistrationForm.entity as MediaToccoDocument)?.fieldMediaFile?.entity?.filemime || '',
    size: (props.entity.fieldRegistrationForm.entity as MediaToccoDocument)?.fieldMediaFile?.entity?.filesize || '',
    url: (props.entity.fieldRegistrationForm.entity as MediaToccoDocument)?.fieldMediaFile?.entity?.url || '',
  },
  props.entity.fieldCourseDocument && {
    title: t('tocco.registration.seminar.seminarDownloads.courseDownloadTitle'),
    type: (props.entity.fieldCourseDocument.entity as MediaToccoDocument)?.fieldMediaFile?.entity?.filemime || '',
    size: (props.entity.fieldCourseDocument.entity as MediaToccoDocument)?.fieldMediaFile?.entity?.filesize || '',
    url: (props.entity.fieldCourseDocument.entity as MediaToccoDocument)?.fieldMediaFile?.entity?.url || '',
  },
].filter(Boolean)
</script>

<template>
  <Section v-if="downloads.length">
    <div class="t-10 t-o-1 tl-7 tl-o-0 ds-o-1">
      <h2 v-animate="{ animation: 'vertical-reveal' }">{{ `Downloads` }}</h2>
      <Downloads :items="downloads" />
    </div>
  </Section>
</template>
